export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.settings-callfrom', {
      url: 'settings-callfrom',
      template: '<nets-callfrom></nets-callfrom>',
    });
};
